import React, { useState } from 'react';
import './Publications.css';

const Publications = () => {
  const [activeFilter, setActiveFilter] = useState('all');

  const publicationsData = [
    {
      id: 1,
      title: "Navigating the Ethical Terrain of AI in Rural Tourism: Privacy and Data Security Imperatives",
      journal: "Journal of Neonatal Surgery",
      type: "scopus",
      category: "Q4 Journal",
      year: "2025",
      doi: "https://doi.org/10.52783/jns.v14.3061",
      status: "published",
      abstract: "Explores ethical considerations and data security challenges in implementing AI solutions for rural tourism development.",
      keywords: ["AI Ethics", "Rural Tourism", "Data Privacy", "Tourism Technology"],
      impact: "Scopus Indexed"
    },
    {
      id: 2,
      title: "Artificial Intelligence in Smart Tourism: Strategic Roles, Rural Impacts, And Implementation Pathways",
      journal: "International Journal of Environmental Sciences",
      type: "scopus",
      category: "Q3 Journal",
      year: "2025",
      doi: "https://doi.org/10.64252/2d96zz07",
      status: "published",
      abstract: "Investigates the strategic implementation of AI in smart tourism with focus on rural community impacts.",
      keywords: ["Smart Tourism", "AI Implementation", "Rural Development", "Tourism Strategy"],
      impact: "Scopus Indexed"
    },
    {
      id: 3,
      title: "Analyzing Potential Impact of Artificial Intelligence on Enhancing Visitor Satisfaction in Rural Tourism",
      journal: "Empirical Economics Letters",
      type: "abdc",
      category: "ABDC C Category",
      year: "2024",
      doi: "https://doi.org/10.5281/zenodo.11080942",
      status: "published",
      abstract: "Examines how AI technologies can enhance visitor experiences and satisfaction in rural tourism destinations.",
      keywords: ["Visitor Satisfaction", "Rural Tourism", "AI Impact", "Tourism Experience"],
      impact: "ABDC Listed"
    },
    {
      id: 4,
      title: "Ethical Implications of AI in Rural Tourism: Privacy & Data Security Concerns",
      journal: "Empirical Economics Letters",
      type: "abdc",
      category: "ABDC C Category",
      year: "2024",
      doi: "https://doi.org/10.5281/zenodo.11477223",
      status: "published",
      abstract: "Discusses privacy and data security implications in AI-driven rural tourism initiatives.",
      keywords: ["AI Ethics", "Data Security", "Privacy Concerns", "Rural Tourism"],
      impact: "ABDC Listed"
    },
    {
      id: 5,
      title: "A METHOD FOR ANALYZING STRATEGIES OF FINANCIAL MANAGEMENT IN ECOMMERCE ENTERPRISES",
      journal: "Indian Patent",
      type: "patent",
      category: "Patent",
      year: "2024",
      doi: "",
      status: "published",
      abstract: "Novel methodology for analyzing and optimizing financial management strategies in e-commerce businesses.",
      keywords: ["Financial Management", "E-commerce", "Business Strategy", "Patent"],
      impact: "Patent Granted"
    },
    {
      id: 6,
      title: "OPEN INNOVATION: COLLABORATING FOR SUCCESSFUL INNOVATIONS",
      journal: "Lingaya's Journal of Professional Studies",
      type: "other",
      category: "Journal Article",
      year: "2023",
      doi: "",
      status: "published",
      abstract: "Explores collaborative innovation models and their impact on organizational success.",
      keywords: ["Open Innovation", "Collaboration", "Innovation Management"],
      impact: "Peer Reviewed"
    },
    {
      id: 7,
      title: "THE ROLE OF ARTIFICIAL INTELLIGENCE IN SHAPING LEADERSHIP STRATEGIES",
      journal: "Lingaya's Journal of Professional Studies",
      type: "other",
      category: "Journal Article",
      year: "2023",
      doi: "",
      status: "published",
      abstract: "Analyzes how AI is transforming leadership approaches and strategic decision-making.",
      keywords: ["AI Leadership", "Strategic Management", "Digital Transformation"],
      impact: "Peer Reviewed"
    },
    {
      id: 8,
      title: "ARTIFICIAL INTELLIGENCE IN BANKING: REDEFINING THE BANKING DYNAMICS AND CUSTOMER EXPERIENCE",
      journal: "Lingaya's Journal of Professional Studies",
      type: "other",
      category: "Journal Article",
      year: "2023",
      doi: "",
      status: "published",
      abstract: "Examines AI applications in banking sector and their impact on customer experience.",
      keywords: ["AI Banking", "Customer Experience", "Financial Technology"],
      impact: "Peer Reviewed"
    },
    {
      id: 9,
      title: "Managing Human Resource Capital for Organizational Success",
      journal: "Book Chapter - Human Resource Analytics",
      type: "book",
      category: "Book Chapter",
      year: "2023",
      doi: "",
      status: "published",
      abstract: "Chapter discussing HR analytics and human capital management for organizational excellence.",
      keywords: ["HR Analytics", "Human Capital", "Organizational Success"],
      impact: "Book Publication"
    },
    {
      id: 10,
      title: "Unleashing the Power of Industry 4.0: From Unmarket to Market",
      journal: "Book Chapter",
      type: "book",
      category: "Book Chapter",
      year: "2023",
      doi: "",
      status: "published",
      abstract: "Explores Industry 4.0 technologies and their market transformation capabilities.",
      keywords: ["Industry 4.0", "Digital Transformation", "Market Innovation"],
      impact: "Book Publication"
    }
  ];

  const filters = [
    { key: 'all', label: 'All Publications', count: publicationsData.length },
    { key: 'scopus', label: 'Scopus Indexed', count: publicationsData.filter(pub => pub.type === 'scopus').length },
    { key: 'abdc', label: 'ABDC Journals', count: publicationsData.filter(pub => pub.type === 'abdc').length },
    { key: 'patent', label: 'Patents', count: publicationsData.filter(pub => pub.type === 'patent').length },
    { key: 'book', label: 'Book Chapters', count: publicationsData.filter(pub => pub.type === 'book').length },
    { key: 'other', label: 'Other Publications', count: publicationsData.filter(pub => pub.type === 'other').length }
  ];

  const filteredPublications = activeFilter === 'all' 
    ? publicationsData 
    : publicationsData.filter(pub => pub.type === activeFilter);

  const getTypeIcon = (type) => {
    switch (type) {
      case 'scopus': return '🔬';
      case 'abdc': return '📊';
      case 'patent': return '💡';
      case 'book': return '📚';
      default: return '📄';
    }
  };

  const getTypeColor = (type) => {
    switch (type) {
      case 'scopus': return '#d32f2f';
      case 'abdc': return '#1976d2';
      case 'patent': return '#388e3c';
      case 'book': return '#7b1fa2';
      default: return '#f57c00';
    }
  };

  return (
    <section id="publications" className="publications-section">
      <div className="container">
        {/* Section Header */}
        <div className="section-header">
          <h2 className="section-title">Research Publications</h2>
          <div className="section-divider"></div>
          <p className="section-subtitle">
            Contributing to academic knowledge through research in AI, Tourism, Management, and Innovation
          </p>
        </div>

        {/* Publication Statistics */}
        <div className="publication-stats">
          <div className="stat-card">
            <div className="stat-icon">📚</div>
            <div className="stat-content">
              <div className="stat-number">{publicationsData.length}+</div>
              <div className="stat-label">Total Publications</div>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">🔬</div>
            <div className="stat-content">
              <div className="stat-number">{publicationsData.filter(pub => pub.type === 'scopus').length}</div>
              <div className="stat-label">Scopus Papers</div>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">📊</div>
            <div className="stat-content">
              <div className="stat-number">{publicationsData.filter(pub => pub.type === 'abdc').length}</div>
              <div className="stat-label">ABDC Journals</div>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">💡</div>
            <div className="stat-content">
              <div className="stat-number">{publicationsData.filter(pub => pub.type === 'patent').length}</div>
              <div className="stat-label">Patents</div>
            </div>
          </div>
        </div>

        {/* Filter Tabs */}
        <div className="filter-tabs">
          {filters.map(filter => (
            <button
              key={filter.key}
              className={`filter-tab ${activeFilter === filter.key ? 'active' : ''}`}
              onClick={() => setActiveFilter(filter.key)}
            >
              <span className="filter-label">{filter.label}</span>
              <span className="filter-count">{filter.count}</span>
            </button>
          ))}
        </div>

        {/* Publications Grid */}
        <div className="publications-grid">
          {filteredPublications.map(publication => (
            <div key={publication.id} className="publication-card">
              <div className="card-header">
                <div className="type-badge" style={{ backgroundColor: getTypeColor(publication.type) }}>
                  <span className="type-icon">{getTypeIcon(publication.type)}</span>
                  <span className="type-label">{publication.category}</span>
                </div>
                <div className="year-badge">{publication.year}</div>
              </div>

              <div className="card-body">
                <h3 className="publication-title">{publication.title}</h3>
                
                <div className="journal-info">
                  <span className="journal-name">{publication.journal}</span>
                  <span className="impact-badge">{publication.impact}</span>
                </div>

                <p className="publication-abstract">{publication.abstract}</p>

                <div className="keywords-list">
                  {publication.keywords.map((keyword, index) => (
                    <span key={index} className="keyword-tag">#{keyword}</span>
                  ))}
                </div>
              </div>

              <div className="card-footer">
                {publication.doi && (
                  <a 
                    href={publication.doi} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="doi-link"
                  >
                    <span className="doi-icon">🔗</span>
                    View DOI
                  </a>
                )}
                <div className="publication-status">
                  <span className="status-dot"></span>
                  Published
                </div>
              </div>

              {/* Hover Effect Layer */}
              <div className="card-hover-effect"></div>
            </div>
          ))}
        </div>

        {/* Research Focus Areas */}
        <div className="research-focus">
          <h3 className="focus-title">Research Focus Areas</h3>
          <div className="focus-areas">
            <div className="focus-area">
              <div className="focus-icon">🤖</div>
              <div className="focus-content">
                <h4>Artificial Intelligence</h4>
                <p>AI applications in tourism, leadership, and organizational management</p>
              </div>
            </div>
            <div className="focus-area">
              <div className="focus-icon">🏞️</div>
              <div className="focus-content">
                <h4>Rural Tourism</h4>
                <p>Sustainable tourism development and technology integration in rural areas</p>
              </div>
            </div>
            <div className="focus-area">
              <div className="focus-icon">📈</div>
              <div className="focus-content">
                <h4>Management</h4>
                <p>Innovation management, HR analytics, and organizational strategy</p>
              </div>
            </div>
            <div className="focus-area">
              <div className="focus-icon">💼</div>
              <div className="focus-content">
                <h4>Business Strategy</h4>
                <p>Financial management, e-commerce, and digital transformation</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Publications;